import React from 'react'
import { TasksList } from './list'

export const GoldenMay2026TasksPage = () => {
  return <TasksList />
}
